import { Grid } from "@mui/material";
import DownloadExcel from "./DeliveriesActions/DownloadExcel.jsx";
import DownloadStatusHistory from "./DeliveriesActions/DownloadStatusHistory.jsx";
import DownloadAllLabels from "./DeliveriesActions/DownloadAllLabels.jsx";
import DownloadSelectedLabels from "./DeliveriesActions/DownloadSelectedLabels.jsx";
import GetTracking from "./DeliveriesActions/GetTracking.jsx";
import Fulfill from "./DeliveriesActions/Fulfill.jsx";
import ReassignDeliveries from "./DeliveriesActions/ReassignDeliveries.jsx";
import MassiveChangeStatusModal from "./DeliveriesActions/MassiveChangeStatusModal.jsx";
import UpsellDeliveries from "./DeliveriesActions/UpsellDeliveries.jsx";
import NavigateDeliveryUpselling from "./DeliveriesActions/NavigateDeliveryUpselling.jsx";

const DeliveryActions = ({
  user,
  isAdmin,
  isAdminStaff,
  filters,
  tableSort,
  pagination,
  deliveriesCount,
  selectedPrintLabels,
  handleSnack,
  pageData,
  setErrorOnRetrieveData,
  onRetryTracking,
  isLoadingTracking,
  trackingProgress,
  onCloseResults,
  isLoading,
  error,
  success,
  changeDriver,
  refetchDeliveries,
  massiveChangeStatus,
}) => {
  const shouldShowAllLabelsBtn = selectedPrintLabels.length === 0;
  const shouldShowSelectedLabelBtn = selectedPrintLabels.length > 0;
  const shouldGetTrackingBtn = filters.statusFilter === "no_tracking";
  const adminCheckout = user.admin_plan?.plan_type === "admin_checkout";
  return (
    <Grid container>
      <DownloadExcel
        user={user}
        startDate={filters.startDate}
        endDate={filters.endDate}
        companyFilter={filters.companyFilter}
        search={filters.search}
        statusFilter={filters.statusFilter}
        deliveriesCount={deliveriesCount}
        setErrorOnRetrieveData={setErrorOnRetrieveData}
        handleSnack={handleSnack}
      />

      {isAdminStaff && (
        <>
          <DownloadStatusHistory
            user={user}
            startDate={filters.startDate}
            endDate={filters.endDate}
            statusFilter={filters.statusFilter}
            deliveriesCount={deliveriesCount}
            setErrorOnRetrieveData={setErrorOnRetrieveData}
            handleSnack={handleSnack}
          />
        </>
      )}

      {/* Show "Download All Labels" button only if selectedPrintLabels is empty */}
      {shouldShowAllLabelsBtn && (
        <DownloadAllLabels
          user={user}
          startDate={filters.startDate}
          endDate={filters.endDate}
          companyFilter={filters.companyFilter}
          search={filters.search}
          statusFilter={filters.statusFilter}
          orderFilter={tableSort.orderFilter}
          orderByFilter={tableSort.orderByFilter}
          page={pagination.page}
          rowsPerPage={pagination.rowsPerPage}
          setErrorOnRetrieveData={setErrorOnRetrieveData}
        />
      )}

      {/* Show "Download Selected Labels" button only if selectedPrintLabels is not empty */}
      {shouldShowSelectedLabelBtn && (
        <DownloadSelectedLabels
          user={user}
          selectedPrintLabels={selectedPrintLabels}
          setErrorOnRetrieveData={setErrorOnRetrieveData}
        />
      )}

      {shouldShowSelectedLabelBtn && (
        <Fulfill
          user={user}
          selectedPrintLabels={selectedPrintLabels}
          setErrorOnRetrieveData={setErrorOnRetrieveData}
        />
      )}

      {shouldGetTrackingBtn && (
        <GetTracking
          isLoading={isLoadingTracking}
          progress={trackingProgress}
          onRetry={onRetryTracking}
          onCloseResults={onCloseResults}
        />
      )}

      {isAdmin && adminCheckout && (
        <ReassignDeliveries
          changeDriver={changeDriver}
          selectedDeliveries={selectedPrintLabels}
          user={user}
          isLoading={isLoading}
          error={error}
          refetchDeliveries={refetchDeliveries}
          success={success}
        />
      )}

      {isAdmin && (
        <>
          <MassiveChangeStatusModal
            selectedDeliveries={selectedPrintLabels}
            loading={isLoading}
            error={error}
            refetchDeliveries={refetchDeliveries}
            success={success}
            massiveChangeStatus={massiveChangeStatus}
          />
          <NavigateDeliveryUpselling />
        </>
      )}

      {(shouldShowSelectedLabelBtn && isAdmin) && (
        <UpsellDeliveries
          selectedDeliveries={selectedPrintLabels}
          isLoading={isLoading}
          error={error}
          refetchDeliveries={refetchDeliveries}
        />
      )}
    </Grid>
  );
};

export default DeliveryActions;
